import type { SelectOption } from '@swf/components/Inputs/components/DropDown/DropDown';
import type { Currency } from '@swf/core/enums';
import type {
  HGGetClubTournStructuresReply,
  TournBuyIn2
} from '@swf/generated/types/api/v0/SwHomeGames';

import { PlayMoney } from './common';

const getOptionsByCurrency = (
  structures: HGGetClubTournStructuresReply | undefined,
  currency: Currency | string
): SelectOption[] => {
  if (!currency || !structures) {
    return [];
  }

  const isPlayMoney = currency === PlayMoney.value;

  const availableBuyIns = (
    isPlayMoney
      ? structures.tournBuyInsPM
      : structures.currencyBuyIns?.find((buyIn) => buyIn.currency === currency)?.tournBuyInBodies ||
        []
  ) as Required<TournBuyIn2>[];

  const buyInsOptions = availableBuyIns.map(({ buyIn, rake, scalePM }) => {
    const buyInCalc = (isPlayMoney ? (buyIn + rake) * scalePM : buyIn + rake) / 100;
    const buyInFormat = Number.isInteger(buyInCalc)
      ? buyInCalc.toString()
      : buyInCalc.toFixed(2).toString();

    return {
      text: buyInFormat,
      value: JSON.stringify({ buyIn, scalePM })
    };
  });

  return buyInsOptions;
};

export default getOptionsByCurrency;
